import React, { useEffect, useState } from 'react';
// import apis from '../../../../apis';
import './index.less';
import AnalysisTabs from './components/analysis-tabs';
import AnalysisFilter from './components/analysis-filter';
import AnalysisTable from './components/analysis-table';
import _ from 'lodash';
const lastTarget = ['search_uv', 'search_item_piece', 'search_ord_deal_ord_amt', 'fo_uctr'];

function FloorAnalysisList(props: { conditions: any }) {
  const { conditions } = props;
  // tabs数据
  const [tabsIdx, setTabsIdx] = useState<number>(0);
  /**
   * 获取 modelId
   * @returns
   */
  const getModeId = (tabsIdxNew = tabsIdx) => {
    let modelId = '';
    switch (tabsIdxNew || tabsIdx) {
      case 0:
        modelId = '0a7205bb-699d-478d-88b3-fdf50f1e2cf9';
        break;
      case 1:
        modelId = 'ce873bf8-8d4f-4a17-8685-72eea265a3b0';
        break;
      case 2:
        modelId = 'f3c6583b-a6d1-4bbc-b03c-00a4b517df6c';
        break;
    }
    return modelId;
  };
  // 接口入参
  const [param, setParam] = useState({
    ...conditions,
    pageSize: 10,
    pageNo: 1,
    indicators: lastTarget,
    orders: {},
    modelId: getModeId(),
  });

  /**
   * 监听指标或是tab数据变化
   * @param data
   */
  const onChange = (data: any) => {
    setParam((value: any) => Object.assign({}, value, data));
    console.log(Object.assign({}, param, data), '更新数据');
  };
  /**
   *
   * @param data 监听tabs变化
   */
  const onChangeTab = (data: any) => {
    setTabsIdx(data.tabsIdx);
    // onChange({ indicators: lastTarget, modelId: getModeId(data.tabsIdx)});
    setParam((value: any)=> {
      const param = {
        ...value,
        indicators: lastTarget,
        modelId: getModeId(data.tabsIdx)
      }
      delete param?.criteria?.['sku_id'];
      delete param?.criteria?.['keyword'];
      delete param?.criteria?.['shop'];
      return {
        ...param
      };
    });
  };
  /**
   *
   * @param data 监听tabs变化
   */
  const onChangeSearch = (data: any) => {
    conditions.criteria = { ...conditions.criteria, ...data };
    if(_.isEmpty(conditions?.criteria?.['sku_id'])){
      delete conditions?.criteria?.['sku_id'];
    }
    if(_.isEmpty(conditions?.criteria?.['keyword'])){
      delete conditions?.criteria?.['keyword'];
    }
    if(_.isEmpty(conditions?.criteria?.['shop'])){
      delete conditions?.criteria?.['shop'];
    }
    setParam((value: any) => Object.assign({}, value, { ...conditions }));
  };
  /**
   * 监听 conditions 变化
   */
  useEffect(() => {
    setParam((value: any) => Object.assign({}, value, { ...conditions }));
  }, [conditions]);

  return (
    <div className="floor-analysis-list">
      {/* 分析tab标签 */}
      <AnalysisTabs onChange={onChangeTab} onChangeSearch={onChangeSearch}/>
      {/* 筛选数据指标 */}
      <AnalysisFilter onChange={onChange} tabsIdx={tabsIdx} />
      {/* 筛选数据列表 */}
      <AnalysisTable tabsIdx={tabsIdx} param={param} />
    </div>
  );
}
export default FloorAnalysisList;
